import { useAuthContext } from '../contexts/AuthContext';

export function useAdmin() {
  const { user } = useAuthContext();
  const isAdmin = 
    user?.app_metadata?.role === 'admin' || 
    user?.user_metadata?.role === 'admin' ||
    user?.role === 'admin';
  
  return {
    isAdmin
  };
}